import { FormSelect, Section } from '../ui';
import { AppSelector } from './AppSelector';
import { PlatformSection } from './PlatformSection';

interface ConditionSectionProps {
    control: any;
    platform: string;
    appList: any[];
    conditions: any[];
    hackingTypesForAndroid: any[];
    hackingTypesForIos: any[];
    osVersionsForAndroid: any[];
    osVersionsForIos: any[];
    t: (key: string) => string;
    loading?: boolean;
    ruleId: string;
}

export const ConditionSection = ({
    control,
    platform,
    appList,
    conditions,
    hackingTypesForAndroid,
    hackingTypesForIos,
    osVersionsForAndroid,
    osVersionsForIos,
    t,
    loading = false,
    ruleId,
}: ConditionSectionProps) => (
    <Section title={t('condition')}>
        <div className="flex flex-col gap-6 max-w-[496px]">
            <PlatformSection control={control} t={t} />

            <AppSelector control={control} appList={appList} t={t} loading={loading} />

            <FormSelect name="ruleId" label={t('select_condition')} placeholder={t('select_condition')} options={conditions} control={control} isShrink={true} />

            <div className="flex gap-2">
                {ruleId === '5' && (
                    <FormSelect
                        name="hackingType"
                        label={t('select_threat_type')}
                        placeholder={t('select_threat_type')}
                        options={platform === 'AOS' ? hackingTypesForAndroid : hackingTypesForIos}
                        control={control}
                        isShrink={true}
                    />
                )}
                {ruleId === '4' && (
                    <FormSelect
                        name="osVersion"
                        label={t('select_os_version')}
                        placeholder={t('select_os_version')}
                        options={platform === 'AOS' ? osVersionsForAndroid : osVersionsForIos}
                        control={control}
                        isShrink={true}
                    />
                )}
            </div>
        </div>
    </Section>
);
